import { yupResolver } from '@hookform/resolvers/yup'
import { Close } from '@mui/icons-material'
import { CardActions, CardContent, Divider, Grid } from '@mui/material'
import {
  Button,
  Card,
  CardHeader,
  IconButton,
  Modal,
  TextFieldC
} from 'components'
import { useRejectProposal } from 'modules/orders/hooks'
import { FormProvider, useForm } from 'react-hook-form'
import { Yup } from 'utils'
import { usePendingReviewModalStore } from '../PendingReviewModal'
import { useRejectProposalStore } from './rejectProposalStore'

type FormData = {
  text: string
}

const schema = Yup.object({
  text: Yup.string().required()
})

function RejectProposalModal() {
  const isOpen = useRejectProposalStore.useIsModalOpen()
  const setIsOpenModal = useRejectProposalStore.useSetModalOpen()
  const proposalId = useRejectProposalStore.useProposalId()

  const setIsPendingReviewOpen = usePendingReviewModalStore.useSetModalIsOpen()

  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      text: ''
    }
  })

  const { handleSubmit, reset } = methods

  const { mutateAsync, isLoading } = useRejectProposal({
    onSuccess: () => setIsPendingReviewOpen(false)
  })

  const onClose = () => {
    setIsOpenModal(false)
  }

  const onSubmit = async (data: FormData) => {
    try {
      const normalizedData = {
        text: data.text,
        proposalId: proposalId
      }
      await mutateAsync(normalizedData)
      setIsOpenModal(false)
      reset()
    } catch {}
  }

  return (
    <FormProvider {...methods}>
      <Modal
        open={isOpen}
        onClose={onClose}
        keepMounted={false}
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)'
        }}
      >
        <Card style={{ padding: 0, minWidth: 300, width: 600 }}>
          <CardHeader
            title={`REJEITAR ORÇAMENTO: ${proposalId || ''}`}
            HeaderRight={
              <IconButton onClick={() => onClose()}>
                <Close />
              </IconButton>
            }
          />
          <Divider />

          <CardContent>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextFieldC name="text" label="Motivo" multiline rows={4} />
              </Grid>
            </Grid>
          </CardContent>
          <Divider />
          <CardActions>
            <div
              style={{
                width: '100%',
                display: 'flex',
                justifyContent: 'space-between',
                gap: '1rem'
              }}
            >
              <Button
                variant="text"
                sx={{
                  width: { sm: 100, md: 200 }
                }}
                onClick={() => onClose()}
              >
                Cancelar
              </Button>
              <Button
                sx={{
                  width: { sm: 100, md: 200 }
                }}
                type="button"
                disabled={isLoading}
                onClick={handleSubmit(onSubmit)}
              >
                Rejeitar
              </Button>
            </div>
          </CardActions>
        </Card>
      </Modal>
    </FormProvider>
  )
}

export default RejectProposalModal
